<template>
  <div class="login_wrapper">
    <div class="animate form login_form">
      <section class="login_content">
        <h3 style="color:#07a8ab; font-size: 50px;">You Plus VPN</h3>
        <br>
        <div align="center">
          
        </div>
        <form @submit="resetPassword">
          <h1>Password Reset</h1>
          <div class="alert alert-warning" v-if="info_message">{{info_message}}</div>

          <div v-if="token_verified">
            <div>
              <input type="password" id="password" v-model="password" name="userPassword" class="form-control" placeholder="Enter New Password">
            </div>
            <div>
              <input type="password" name="password_confirmation" id="password_confirmation" v-model="password_confirmation" class="form-control" placeholder="Confirm Password">
            </div>
          </div>
          <div v-else>
            <div>
              <input type="text" name="email" id="email" v-model="email" class="form-control" placeholder="Enter Email Address">
            </div>
          </div>

          <div>
            <button type="submit" name="commit" value="Submit" class="btn btn-default" style="background-color: #07a8ab; color:#fff; float: left;">{{button_name}}</button>
            
            <router-link :to="{name: 'loginView'}" class="reset_pass" style="margin-right: 0px;">
              Login Now
            </router-link>
            <br><br><br><br>
          </div>

          <div class="clearfix"></div>
          <div class="separator">
            <div class="clearfix"></div>
            <br />
            <div> <p></p> </div>
          </div>

        </form>
      </section>
    </div>
  </div>
</template>
<script>
   import axios from 'axios'
   import {mapGetters} from 'vuex' 
   export default {
     name: "PasswordReset",
     data() {
        return {
          token_verified : false,
          button_name : 'Submit',
          email: '',
          password: '', 
          password_confirmation: '', 
          info_message: '',
          api_public_path : process.env.VUE_APP_APIRESELLERPUBLIC,
          loadNow : false,
          support_admin_id : '',
          logoImg : '/assets/img/nologo.png',
          token : '',
          id : ''
        };
     },
     created(){
        var rootObject = this;
        var panel = this.$route.params.panel;
        if(panel == undefined){
          rootObject.com_pageNotFound();
        }
        else{
          if(this.$store.getters.getLoginStatus){
            axios.defaults.headers.common['panel'] = panel;
          }
          //Get Panel Configurations
          axios.get('panel-setting', {
            params: {
              panel_name: panel
            }
          })
          .then(function (response) {
            //console.log(response.data);  
            if(response.data.settings == null){
              rootObject.com_pageNotFound();
            }else{
              let panelparam = {
                'panel': panel,
                'panel_settings':response.data.settings,
              };
              rootObject.com_setPanelData(panelparam);

              var logoImgURL = rootObject.api_public_path+'uploads/images/'+response.data.settings.logo_images;
              rootObject.checkIfImageExists(logoImgURL, (exists) => {
                if (exists) {
                  rootObject.logoImg = logoImgURL;
                  //$("#img_logo").attr('src', logoImgURL); 
                }
              })
              
              if(response.data.settings.favicon){
                $("#favicon").attr('href', rootObject.api_public_path+'uploads/images/'+response.data.settings.favicon);
              }else{
                $("#favicon").attr('href', '/assets/img/symlex_logo.png');
              }
              window.document.title = "Admin Panel - " + (response.data.settings.com_name).toUpperCase();
              rootObject.loadNow = true;
              rootObject.getRequestedDataDecrypt();
            }
          })
          .catch(function (error) {
            rootObject.com_pageNotFound();
          });
        }
     },
     methods: {

      checkIfImageExists(url, callback) {
        const img = new Image();
        img.src = url;
        if (img.complete) {
          callback(true);
        } else {
          img.onload = () => {
            callback(true);
          };
          img.onerror = () => {
            callback(false);
          };
        }
      },

      getRequestedDataDecrypt(){
        var urlParams = new URLSearchParams(window.location.search);
        var pass_reset_token = "";
        if(urlParams.has('pass_reset_token')){
          pass_reset_token = urlParams.get('pass_reset_token');
          pass_reset_token = pass_reset_token.split(' ').join('+');
          //console.log(pass_reset_token);
          var decodedString  = this.com_DecryptString(pass_reset_token);
          var decodedData = JSON.parse(decodedString);
          this.id =  decodedData.id;
          this.token =  decodedData.verify_token;

          var url = "reset_password_validate";
          var param = {
            id: this.id,
            token: this.token
          };
          var addtionalData = {
            doValidationToken : true
          };
          this.callApiWithAxios(url, param, addtionalData);
          //console.log(decodedData);
        }
      },

      resetPassword(e) {
        e.preventDefault();
        if(this.token_verified){
          if(!this.password){
            toastr.error('Password is Mandatory', "Required !!!");
            $("#password").focus();
            return 0;
          }
          if(!this.password_confirmation){
            toastr.error('Confirm Password is Mandatory', "Required !!!");
            $("#password_confirmation").focus();
            return 0;
          }
          if(this.password != this.password_confirmation){
            toastr.error('Confirm Password does not match', "Alert !!!");
            $("#password_confirmation").focus();
            return 0; 
          }
          var url = 'save_reset_password'; 
          var param = {
            id: this.id,
            token: this.token,
            password: this.password,
            password_confirmation: this.password_confirmation
          };
        }else{
          if(!this.email){
            toastr.error('Email is Mandatory', "Required !!!");
            $("#email").focus();
            return 0;
          }
          var url = 'reset_password_request'; 
          var param = {
            email: this.email
          };
        }
        this.callApiWithAxios(url, param);
      },

      callApiWithAxios(url, param, addtionalData = []){
        var rootObject = this;
        var panel = localStorage.getItem("panel");
        loader.show();
        axios.post(url, param)
        .then(function (response) {
          //console.log(addtionalData.doValidationToken);
          //console.log(response);
          loader.hide();
          rootObject.info_message =  response.data.message;

          if(addtionalData.doValidationToken==true){
            if(response.data.validate==true){
              rootObject.token_verified = true;
              rootObject.button_name = "Reset Now";
            }
          }
          rootObject.password = '';
          rootObject.password_confirmation = '';
          setTimeout(function(){  
            rootObject.info_message = '';
          }, 5000);
        })
        .catch(function (error) {
            let alertmessage = "";
            if(error.response.data){
              for (var prop in error.response.data) {
                alertmessage += " "+error.response.data[prop];
              }
            }
            loader.hide();
            //console.log(alertmessage);
            rootObject.info_message =  alertmessage;
            setTimeout(function(){  
              rootObject.info_message = '';
            }, 3000);
        });
      }

    
     },
     computed: {
       ...mapGetters({
         panelData : 'getPanelData'
       })
     },
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>